var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A47B8",
    d: "M1.75 0L17.5 0C18.466497 -1.7754286e-16 19.25 0.78350168 19.25 1.75L19.25 12.25C19.25 13.216498 18.466497 14 17.5 14L1.75 14C0.78350168 14 9.4735934e-16 13.216498 8.8817842e-16 12.25L0 1.75C-1.1836191e-16 0.78350168 0.78350168 1.1836191e-16 1.75 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M2.0478063 0L0 0L0 2.3333364L17.191038 14L19.25 14L19.25 11.666637L2.0478063 0Z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M0.68300664 0L19.25 12.633075L19.25 14L18.582987 14L0 1.3538525L0 0L0.68300664 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(5.34058e-05 0)",
    d: "M17.416647 0L19.250034 0L19.250034 2.3333364C19.250034 2.3333364 7.3423166 10.106162 1.8333341 14L0 14L0 11.666637L17.416647 0Z",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M19.25 0L18.628313 0L0 12.643925L0 14L0.68300664 14L19.25 1.3640813L19.25 0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M7.0006561 0L12.2654 0L12.2654 4.3183613L19.25 4.3183613L19.25 9.678812L12.2654 9.678812L12.2654 14L7.0006561 14L7.0006561 9.678812L0 9.678812L0 4.3183613L7.0006561 4.3183613L7.0006561 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M8.1052647 0L11.1447 0L11.1447 5.3846188L19.25 5.3846188L19.25 8.6153812L11.1447 8.6153812L11.1447 14L8.1052647 14L8.1052647 8.6153812L0 8.6153812L0 5.3846188L8.1052647 5.3846188L8.1052647 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/english_flag.d443585322cb6f501d25a03cc84a533c.svg";
export { ForwardRef as ReactComponent };